var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"max-w-7xl mx-auto sm:px-2 lg:px-8"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }